module.exports = __webpack_public_path__ + "static/img/companyProducts2.63276e0a.png";